module.exports = __webpack_public_path__ + "img/assisi-L.b3dfde04.jpg";